import { useLazyQuery } from '@apollo/client'
import { FirebaseError } from '@firebase/util'
import { styled } from '@mui/material'
import { getAuth } from 'firebase/auth'
import { useEffect, useRef } from 'react'
import ViewTitle from '../../../components/ViewTitle'
import { BucketsByUserIdDocument } from '../../../graphql/generated'
import { modalVar } from '../../../providers/apollo/cache'
import logger from '../../../utils/logger'
import useLoginFirebase from '../../auth/hooks/useLogin'
import Plans from '../components/plans/Plans'
import Benefits from './components/Benefits'
import Blocks from './components/Blocks'
import Carousel from './components/Carousel'
import Devices from './components/Devices'
import Disclaimer from './components/Disclaimer'

/**
 * Renders primary homepage
 */

const StyledMain = styled('main')(({ theme }) => ({
  maxWidth: theme.breakpoints.values.xl,
  margin: '0 auto'
}))

export default function Homepage() {
  const userId = getAuth().currentUser?.uid
  const { attemptRedirect } = useLoginFirebase()
  const attemptRedirectRef = useRef(attemptRedirect)
  const [getBucketsQuery] = useLazyQuery(BucketsByUserIdDocument)

  // Redirect users with an active session their new architecture bucket. Falls back to old architecture
  useEffect(() => {
    if (!userId) {
      return
    }

    const checkTermsStatus = async () => {
      if (!userId) {
        throw new FirebaseError('auth/unauthenticated', 'Failed to fetch buckets. Unauthenticated.')
      }
      const variables = { userId }
      const res = getBucketsQuery({ variables })
      if ((await res).data?.userProfile?.latestTermsAccepted !== true) {
        logger.info('Terms and conditions not accepted')
        modalVar('termsAndConditionsLogin')
      } else {
        attemptRedirectRef
          .current()
          .then((success) => {
            if (success === true) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('Failed to redirect user to new architecture. Attempting to redirect to old architecture.'))
          })
          .catch((error) => {
            logger.info(error)
            window.location.href = `/u/${userId}`
          })
      }
    }

    checkTermsStatus()
  }, [getBucketsQuery, userId])

  return (
    <>
      <ViewTitle title="Photo Storage" />
      <StyledMain>
        <Carousel />
        <Plans />
        <Devices />
        <Blocks />
        <Benefits />
        <Disclaimer />
      </StyledMain>
    </>
  )
}
